var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirGoldBlackLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 58,
    viewBox: "0 0 96 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_584_657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.6635 57.2901L32.2265 57.3277L16.4707 29.9415L32.1571 2.51229L63.5941 2.47461L79.3446 29.8608L63.6635 57.2901Z",
    stroke: "#222222",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7197 43.6982L47.6677 56.7669L24.8506 43.0523L25.0801 16.2636L48.1321 3.18945L70.9545 16.9095L70.7197 43.6982Z",
    stroke: "#222222",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8001 21.7539H47.2949V30.3659H48.8001V21.7539Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7678 18.832H47.252V20.2907H48.7678V18.832Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.891 27.9759H32.9204L31.853 30.4249H30.2197L35.2635 18.8633H37.4411L42.5863 30.4249H40.9851L39.891 27.9759ZM39.4373 26.9963L36.3844 19.929L33.3688 26.9963H39.4373Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4941 30.4249V18.8633H61.0697C62.55 18.8633 63.5925 19.1091 64.1974 19.6007C64.8005 20.0905 65.1048 20.9463 65.1048 22.1574C65.1048 23.2339 64.9393 23.9713 64.6084 24.3911C64.1018 24.8919 63.4279 25.1837 62.719 25.2093C64.1814 25.3026 64.9126 26.0489 64.9126 27.4484V30.4034H63.3381V27.7659C63.3381 26.4131 62.6425 25.7385 61.2512 25.7421H56.0473V30.4249H54.4941ZM56.0473 24.6387H60.536C61.7209 24.6387 62.5268 24.488 62.9592 24.1866C63.1965 23.9767 63.3794 23.7116 63.4919 23.4142C63.6045 23.1169 63.6433 22.7963 63.605 22.4803C63.605 21.4361 63.4449 20.7525 63.1246 20.4404C62.8044 20.1282 62.1372 19.9667 61.0697 19.9667H56.0473V24.6387Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2324 33.9509H61.9827C62.3189 33.9509 64.5286 33.854 64.9876 35.1458C64.9876 35.1458 65.4359 35.8617 65.2811 37.9555C65.2811 37.9555 65.1744 39.5702 64.5606 40.1085C64.5606 40.1085 64.0589 40.6951 62.6071 40.7382H57.3338V39.7263H58.017H62.1428C62.1428 39.7263 63.4397 39.7263 63.7867 39.2365C63.7867 39.2365 64.1603 38.7467 64.0909 36.9489C64.0909 36.9489 64.0909 35.6948 63.728 35.3342C63.728 35.3342 63.5305 34.9466 61.8866 34.9735H57.2431L57.2324 33.9509Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.298 34.7266H58.001V39.8722H59.298V34.7266Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9672 37.5833H37.6126C37.6202 37.7339 37.6202 37.8848 37.6126 38.0354C37.6126 39.198 37.4258 39.9193 37.0468 40.1884C36.6679 40.4575 35.6858 40.6029 34.0899 40.6029C32.5848 40.6029 31.617 40.4378 31.1864 40.1077C30.7559 39.7775 30.5424 39.0455 30.5459 37.9116V36.9589V36.3884C30.5459 35.4303 30.7808 34.7736 31.2611 34.4776C31.7415 34.1815 32.7022 34.0039 34.1486 34.0039C35.5951 34.0039 36.5344 34.1062 36.9561 34.3161C37.3777 34.526 37.5912 34.8543 37.5912 35.5595H36.6892C36.6892 35.0212 36.4971 34.9297 36.2089 34.8059C35.4756 34.6397 34.7223 34.5817 33.9725 34.6337C32.8623 34.6337 32.1632 34.7305 31.8856 34.9297C31.6081 35.1288 31.464 35.6348 31.464 36.4368V37.2926V38.213C31.464 39.0312 31.6187 39.5317 31.9283 39.7147C32.2379 39.9031 33.0705 39.9946 34.4155 39.9946C35.4456 39.9946 36.0861 39.9085 36.3263 39.7309C36.5665 39.5533 36.8333 39.3003 36.6946 38.3422C36.6946 38.283 36.6946 38.4983 36.6519 38.2938H33.9405L33.9672 37.5833Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.659 34.0312C45.2744 34.0312 46.2849 34.2107 46.6906 34.5695C47.0962 34.9283 47.2973 35.8254 47.2937 37.2608C47.2937 38.7966 47.0998 39.7439 46.7119 40.1027C46.3241 40.4616 45.3064 40.641 43.659 40.641C42.0204 40.641 40.9903 40.458 40.6113 40.1027C40.2324 39.7475 40.0189 38.8163 40.0189 37.3253V36.8732V36.2596C39.9794 35.9245 40.0299 35.5849 40.1651 35.2762C40.3003 34.9675 40.5153 34.7012 40.7875 34.5049C41.3212 34.1927 42.2659 34.0312 43.659 34.0312ZM43.659 34.6502C42.3104 34.6502 41.5205 34.7633 41.2892 34.9893C41.0597 35.2154 40.9423 35.9959 40.9423 37.3253C40.9423 38.6548 41.0597 39.4461 41.2892 39.6721C41.5187 39.8982 42.3086 40.0112 43.659 40.0112C45.0093 40.0112 45.7939 39.8982 46.0394 39.6721C46.2849 39.4461 46.381 38.6656 46.381 37.3253V36.2973C46.381 35.5814 46.2209 35.1293 45.906 34.9355C45.5911 34.7417 44.8332 34.6341 43.6536 34.6341L43.659 34.6502Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0892 34.0957V39.8819H55.4819V40.5547H50.1445V34.0957H51.0892Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_584_657"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 58,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirGoldBlackLogo);
export default __webpack_public_path__ + "static/media/airGoldBlackLogo.cf4d8ca2e603ad724c160e6076bddae6.svg";
export { ForwardRef as ReactComponent };